import _ from 'lodash';
import * as types from './types';

export const resetAppliedFilters = () => (dispatch) => {
  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: { appliedFiltersMarketView: {} },
  });
};

export const deleteAppliedFilter = (key) => (dispatch, getState) => {
  const previousAppliedFilters = getState().FiltersReducer
    .appliedFiltersMarketView;
  const newFilters = _.omit(previousAppliedFilters, key);

  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: { appliedFiltersMarketView: newFilters },
  });
};

export const removeStateFromAppliedFilters = (state) => (
  dispatch,
  getState,
) => {
  const previousAppliedFilters = getState().FiltersReducer
    .appliedFiltersMarketView;
  const previousAppliedStates = getState().FiltersReducer
    .appliedFiltersMarketView.state;

  const radioValue = Object.keys(
    getState().FiltersReducer.appliedFiltersMarketView.state,
  )[0];

  const updatedArray = previousAppliedStates[radioValue].filter(
    (el) => el !== state,
  );

  if (updatedArray.length) {
    dispatch({
      type: types.SET_APPLIED_FILTERS,
      payload: {
        currentPage: 0,
        appliedFiltersMarketView: {
          ...previousAppliedFilters,
          state: { [radioValue]: updatedArray },
        },
      },
    });
  } else {
    dispatch(deleteAppliedFilter('state'));
  }
};

export const removePropertyTypeFromAppliedFilters = (propertyType) => (
  dispatch,
  getState,
) => {
  const previousAppliedFilters = getState().FiltersReducer
    .appliedFiltersMarketView;
  const previousAppliedPropertyTypes = getState().FiltersReducer
    .appliedFiltersMarketView.propertyType;

  const radioValue = Object.keys(
    getState().FiltersReducer.appliedFiltersMarketView.propertyType,
  )[0];

  const updatedArray = previousAppliedPropertyTypes[radioValue].filter(
    (el) => el !== propertyType,
  );

  if (updatedArray.length) {
    dispatch({
      type: types.SET_APPLIED_FILTERS,
      payload: {
        currentPage: 0,
        appliedFiltersMarketView: {
          ...previousAppliedFilters,
          propertyType: { [radioValue]: updatedArray },
        },
      },
    });
  } else {
    dispatch(deleteAppliedFilter('propertyType'));
  }
};

export const setAppliedFilters = (key, filter) => (dispatch, getState) => {
  const previousAppliedFilters = getState().FiltersReducer
    .appliedFiltersMarketView;

  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: {
      currentPage: 0,
      appliedFiltersMarketView: { ...previousAppliedFilters, [key]: filter },
    },
  });
};
